import React from 'react';
import { hexToRgba, useStacklineTheme } from '@stackline/ui';
import { BlueCancel } from 'src/components/SvgIcons/SvgIcons';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Box } from '@mui/system';
import UnstyledButton from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/UnstyledFilterButton';

/**
 * A chip item that displays a label and a delete button.
 */
const ChipItem = ({ label, handleDelete }: { label: string; handleDelete?: () => void }) => {
  const theme = useStacklineTheme();

  return (
    <Box
      display="flex"
      flexShrink={0}
      alignItems="center"
      gap="8px"
      justifyContent="space-between"
      height="24px"
      maxWidth="167px"
      padding="4px 8px"
      borderRadius="12px"
      sx={{
        backgroundColor: hexToRgba(theme.colors.primaryLight, 0.2),
        border: hexToRgba(theme.colors.primaryLight, 0.2)
      }}
    >
      <Text
        variant="body3"
        color="primary"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
        title={label}
      >
        {label}
      </Text>
      {handleDelete && (
        <UnstyledButton style={{ width: '12px', height: '12px' }} onClick={() => handleDelete()}>
          <BlueCancel style={{ width: '12px', height: '12px' }} />
        </UnstyledButton>
      )}
    </Box>
  );
};

export default ChipItem;
